import { Table } from "containers/Table";
import {
  Button,
  Container,
  ContainerInputPesquisa,
  ContainerValorTotal,
  DivAcoes,
  Header,
  Icon,
  InputPesquisa,
  InputWrapper,
  TextoHeader,
} from "./style";
import { IColum } from "containers/Table/interfaces";
import { FaPen, FaTrash } from "react-icons/fa";
import {
  ICustoAdicionar,
  IProcessoCriarLote,
} from "../../../interface/IProcessosCriarLote";
import { formatarDinheiro } from "_utils/Money";
import { BotaoRemoverCusto } from "../BotãoRemoverCusto";
import { ModalCertezaRemoverProcesso } from "./ModalCertezaRemoverProcesso";
import { useEffect, useState } from "react";
import { ModalSucessoRemoverProcessos } from "./ModalSucessoRemoverProcessos";
import { ModalEditarCustos } from "./ModalEditarCustos";
import { ModalCertezaRemoverCustoProcesso } from "./ModalCertezaRemoverCustoProcesso";

interface IProps {
  clearRows: boolean;
  setRowsSelected: (ids: number[]) => void;
  processos: IProcessoCriarLote[];
  selectedRows: IProcessoCriarLote[];
  setProcessos: React.Dispatch<React.SetStateAction<IProcessoCriarLote[]>>;
  tela: string;
}
export function ListaResumoProcessosCriarLote({
  clearRows,
  setRowsSelected,
  processos,
  selectedRows,
  setProcessos,
  tela,
}: IProps) {
  const [showModalCertezaRemoverProcesso, setShowModalCertezaRemoverProcesso] =
    useState<boolean>(false);
  const [showModalSucessoRemoverProcesso, setShowModalSucessoRemoverProcesso] =
    useState<boolean>(false);
  const [showModalEditarCustos, setShowModalEditarCustos] =
    useState<boolean>(false);
  const [showModalCertezaRemoverCusto, setShowModalCertezaRemoverCusto] =
    useState<boolean>(false);

  const createDefaultCustoRemoverProcesso = (): ICustoAdicionar => ({
    idDescricao: 0,
    label: "",
    valor: "",
  });
  const [custoRemoverProcesso, setCustoRemoverProcesso] =
    useState<ICustoAdicionar>(createDefaultCustoRemoverProcesso());

  const createDefaultProcessoEditar = (): IProcessoCriarLote => ({
    idProcesso: 0,
    placa: null,
    chassi: null,
    nomeEmpresa: null,
    nomeDivisao: null,
    servico: null,
    custos: [],
  });
  const [processoEditar, setProcessoEditar] = useState<IProcessoCriarLote>(
    createDefaultProcessoEditar(),
  );

  const [dadosTabela, setDadosTabela] = useState<IProcessoCriarLote[]>([
    ...processos,
  ]);
  const [textoBusca, setTextoBusca] = useState<string>("");
  const onChangePesquisa = () => {
    if (!textoBusca) {
      setDadosTabela([...processos]);
      return;
    }

    setDadosTabela(
      [...processos].filter((item) => {
        if (
          `${item.idProcesso}`.includes(textoBusca) ||
          (item.placa &&
            item.placa.replace("-", "").includes(textoBusca.replace("-", "")))
        ) {
          return true;
        }
        return false;
      }),
    );
  };

  useEffect(() => {
    onChangePesquisa();
  }, [textoBusca, processos]);

  const removerCusto = (idDescricao: number, idProcesso: number) => {
    setProcessos((processosAtuais: IProcessoCriarLote[]) =>
      processosAtuais
        .map((processo) => {
          if (processo.idProcesso !== idProcesso) {
            return processo;
          }

          const novosCustos = [...processo.custos].filter(
            (custo) => custo.idDescricao !== idDescricao,
          );

          return {
            ...processo,
            custos: novosCustos,
          };
        })
        .filter((processo) => processo.custos.length > 0),
    );
  };

  const onRemoverDoLote = () => {
    setProcessos(
      [...processos].filter(
        (processo) =>
          !selectedRows.some((row) => row.idProcesso == processo.idProcesso),
      ),
    );
    setShowModalCertezaRemoverProcesso(false);
    setShowModalSucessoRemoverProcesso(true);
  };

  const columns: IColum<IProcessoCriarLote>[] = [
    {
      name: "Processo",
      selector: ({ idProcesso }: IProcessoCriarLote) => idProcesso,
    },
    {
      name: "Placa",
      selector: ({ placa }: IProcessoCriarLote) => placa ?? "--",
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IProcessoCriarLote) => chassi ?? "--",
      width: "200px",
    },
    {
      name: "Empresa",
      selector: ({ nomeEmpresa }: IProcessoCriarLote) => nomeEmpresa ?? "--",
      width: "200px",
    },
    {
      name: "Divisão",
      selector: ({ nomeDivisao }: IProcessoCriarLote) => nomeDivisao ?? "--",
      width: "200px",
    },
    {
      name: "Serviços",
      selector: ({ servico }: IProcessoCriarLote) => servico ?? "--",
      width: "250px",
    },
    {
      name: "Custos lançados",
      selector: ({ custos, idProcesso }: IProcessoCriarLote) =>
        custos.length ? (
          <BotaoRemoverCusto
            custos={custos}
            onClickRemover={removerCusto}
            idProcesso={idProcesso}
          />
        ) : (
          "--"
        ),
      width: "320px",
    },
    {
      name: "Custos (R$)",
      selector: ({ custos }: IProcessoCriarLote) =>
        custos.length
          ? formatarDinheiro(
              custos.reduce(
                (total, custo) => total + Number(custo.valor || 0),
                0,
              ),
            )
          : "--",
      width: "250px",
    },
    {
      name: "Ações",
      selector: (processo: IProcessoCriarLote) => (
        <FaPen
          onClick={() => {
            setProcessoEditar(processo);
            setShowModalEditarCustos(true);
          }}
          style={{ cursor: "pointer" }}
          title="Editar custos"
        />
      ),
      width: "100px",
    },
  ];

  const handleCloseModalRemoverCustoProcesso = () => {
    setShowModalCertezaRemoverCusto(false);
    setCustoRemoverProcesso(createDefaultCustoRemoverProcesso());
    setShowModalEditarCustos(true);
  };

  const onSubmitModalRemoverCustoProcesso = () => {
    setProcessos((processosAtuais: IProcessoCriarLote[]) =>
      processosAtuais
        .map((processo) => {
          if (processo.idProcesso !== processoEditar.idProcesso) {
            return processo;
          }

          const novosCustos = [...processo.custos].filter(
            (custo) => custo.idDescricao !== custoRemoverProcesso.idDescricao,
          );

          return {
            ...processo,
            custos: novosCustos,
          };
        })
        .filter((processo) => processo.custos.length > 0),
    );
    setProcessoEditar((processo: IProcessoCriarLote) => {
      const novosCustos = [...processo.custos].filter(
        (custo) => custo.idDescricao !== custoRemoverProcesso.idDescricao,
      );

      return {
        ...processo,
        custos: novosCustos,
      };
    });

    handleCloseModalRemoverCustoProcesso();
  };

  const onConfirmModalEditarCustos = () => {
    setProcessos((processosAtuais: IProcessoCriarLote[]) =>
      processosAtuais
        .map((processo) => {
          if (processo.idProcesso !== processoEditar.idProcesso) {
            return processo;
          }

          const novosCustos = [...processoEditar.custos];

          return {
            ...processo,
            custos: novosCustos,
          };
        })
        .filter((processo) => processo.custos.length > 0),
    );
    setShowModalEditarCustos(false);
    setProcessoEditar(createDefaultProcessoEditar());
  };

  return (
    <Container>
      <Header>
        <TextoHeader>Editar processos</TextoHeader>
        <DivAcoes>
          <Button
            variante="primary"
            outline
            onClick={() => {
              setShowModalCertezaRemoverProcesso(true);
            }}
            disabled={!selectedRows.length}
          >
            <FaTrash /> Remover do lote
          </Button>
        </DivAcoes>
      </Header>
      <hr />
      <ContainerInputPesquisa>
        <ContainerValorTotal>
          Custos adicionados:{" "}
          <strong>
            {processos.filter((processo) => processo.custos.length).length
              ? formatarDinheiro(
                  processos
                    .map((processo) =>
                      processo.custos.reduce(
                        (total, custo) => total + Number(custo.valor || 0),
                        0,
                      ),
                    )
                    .reduce((total, custo) => total + Number(custo || 0), 0),
                )
              : "--"}
          </strong>
        </ContainerValorTotal>
        <InputWrapper>
          <Icon />
          <InputPesquisa
            onChange={(e) => {
              setTextoBusca(e.target.value);
            }}
            placeholder="ID Processo ou placa"
          />
        </InputWrapper>
      </ContainerInputPesquisa>
      <Table
        key={`${tela}-${processos.length}`}
        keyField="idProcesso"
        columns={columns}
        data={dadosTabela}
        loading={false}
        noSubHeader
        possuiTooltip={false}
        selectableRows
        setRowsSelected={setRowsSelected}
        headerFixo
        clearSelectedRows={clearRows}
      />
      <ModalCertezaRemoverProcesso
        show={showModalCertezaRemoverProcesso}
        onConfirm={onRemoverDoLote}
        handleClose={() => {
          setShowModalCertezaRemoverProcesso(false);
        }}
      />
      <ModalSucessoRemoverProcessos
        show={showModalSucessoRemoverProcesso}
        handleClose={() => setShowModalSucessoRemoverProcesso(false)}
      />
      <ModalEditarCustos
        show={showModalEditarCustos}
        handleClose={() => {
          setShowModalEditarCustos(false);
          setProcessoEditar(createDefaultProcessoEditar());
        }}
        processoEditar={processoEditar}
        onConfirm={onConfirmModalEditarCustos}
        setProcessoEditar={setProcessoEditar}
        setShowModalEditarCustos={setShowModalEditarCustos}
        setShowModalCertezaRemoverCusto={setShowModalCertezaRemoverCusto}
        setCustoRemoverProcesso={setCustoRemoverProcesso}
      />
      <ModalCertezaRemoverCustoProcesso
        show={showModalCertezaRemoverCusto}
        handleClose={handleCloseModalRemoverCustoProcesso}
        onConfirm={onSubmitModalRemoverCustoProcesso}
      />
    </Container>
  );
}
